import React from "react";
import Sellpagetwo from "Pages/Sell-Crypto";


const Selltheme = () => {
  return (
    <React.Fragment>
       <Sellpagetwo/>
    </React.Fragment>
  );
};

export default Selltheme;
